export const firebaseConfig = {
    apiKey: 'AIzaSyDcmMDBGgkYhxtioQo0dHBxn5h1Zbyj_-E',
    authDomain: 'sbg-winweb.firebaseapp.com',
    databaseURL: 'https://sbg-winweb.firebaseio.com',
    projectId: 'sbg-winweb',
    storageBucket: 'sbg-winweb.appspot.com',
    messagingSenderId: '383027506808',
    appId: '1:383027506808:web:8d8ec32cf961e8e239c78d',
    measurementId: 'G-MBKC1R6G8V'
};
